import Link from "next/link";
import { Container } from "@/components/layout/container";

export default function PaiementSuccesPage() {
  return (
    <section
      className="section min-h-screen"
      style={{
        background:
          "linear-gradient(180deg, rgba(244,215,231,0.96) 0%, rgba(247,225,235,0.94) 38%, rgba(245,210,227,0.92) 100%)",
      }}
    >
      <Container>
        <div className="mx-auto max-w-4xl">
          <div className="overflow-hidden rounded-[34px] border border-[var(--border)] bg-[var(--background)] shadow-[var(--shadow)]">
            <div className="relative border-b border-[var(--border)] bg-[var(--background)] px-8 py-10 text-center sm:px-10 sm:py-12">
              <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full border border-[var(--border)] bg-[var(--background)] text-[var(--foreground)] shadow-[var(--shadow)] -mt-4">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="h-9 w-9"
                >
                  <path d="M20 6 9 17l-5-5" />
                </svg>
              </div>

              <p className="mt-3 font-mono text-[11px] uppercase tracking-[0.18em] text-[var(--accent)]/85">
                Paiement confirmé
              </p>

              <h1 className="mt-4 text-5xl leading-[0.96] sm:text-6xl">
                Merci pour votre commande
              </h1>

              <div className="mt-6 flex justify-center">
                <p className="max-w-2xl text-center text-balance text-base leading-7 text-[var(--foreground)]/74">
                  Votre paiement a bien été pris en compte. Votre commande est désormais
                  enregistrée et va pouvoir être préparée avec soin. Vous pouvez déjà la
                  retrouver dans votre espace client.
                </p>
              </div>
            </div>

            <div className="border-t border-[var(--border)] px-8 py-8 sm:px-10">
              <div className="p-6 sm:p-7">
                <p className="font-mono text-[11px] uppercase tracking-[0.18em] text-[var(--foreground)]/55">
                  Accès rapides
                </p>

                <h2 className="mt-4 text-3xl leading-tight sm:text-4xl">
                  Tout est prêt.
                </h2>

                <p className="mt-4 max-w-2xl text-sm leading-7 text-[var(--foreground)]/68 sm:text-base">
                  Retrouvez votre commande dans votre compte client ou revenez directement à la boutique pour continuer vos achats.
                </p>

                <div className="mt-6 grid gap-4 md:grid-cols-2">
                  <Link
                    href="/compte"
                    className="group rounded-[24px] border border-[var(--border)] bg-[var(--background)] p-5 transition hover:-translate-y-0.5 hover:border-[var(--primary)]"
                  >
                    <div className="flex items-start justify-between gap-4">
                      <div>
                        <p className="font-mono text-[11px] uppercase tracking-[0.18em] text-[var(--accent)]/75">
                          Compte client
                        </p>
                        <h3 className="mt-3 text-xl leading-tight">Voir ma commande</h3>
                        <p className="mt-3 text-sm leading-6 text-[var(--foreground)]/68">
                          Suivre son statut, vérifier ses informations et retrouver l’historique.
                        </p>
                      </div>

                      <span className="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-[var(--border)] bg-[var(--background)] text-[var(--foreground)]/72 transition group-hover:border-[var(--primary)] group-hover:text-[var(--primary)]">
                        →
                      </span>
                    </div>
                  </Link>

                  <Link
                    href="/boutique"
                    className="group rounded-[24px] border border-[var(--border)] bg-[var(--background)] p-5 transition hover:-translate-y-0.5 hover:border-[var(--primary)]"
                  >
                    <div className="flex items-start justify-between gap-4">
                      <div>
                        <p className="font-mono text-[11px] uppercase tracking-[0.18em] text-[var(--accent)]/75">
                          Boutique
                        </p>
                        <h3 className="mt-3 text-xl leading-tight">Retourner au shop</h3>
                        <p className="mt-3 text-sm leading-6 text-[var(--foreground)]/68">
                          Revenir aux pelotes, kits et nouveautés pour continuer la découverte.
                        </p>
                      </div>

                      <span className="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-[var(--border)] bg-[var(--background)] text-[var(--foreground)]/72 transition group-hover:border-[var(--primary)] group-hover:text-[var(--primary)]">
                        →
                      </span>
                    </div>
                  </Link>
                </div>

                <div className="mt-8 grid gap-4 sm:grid-cols-2">
                  <Link
                    href="/compte"
                    className="inline-flex items-center justify-center rounded-full bg-[var(--primary)] px-6 py-3 text-sm font-medium text-white transition hover:opacity-90"
                  >
                    Aller à mon compte
                  </Link>

                  <Link
                    href="/boutique"
                    className="inline-flex items-center justify-center rounded-full border border-[var(--border)] bg-[var(--background)] px-6 py-3 text-sm font-medium transition hover:border-[var(--accent)] hover:text-[var(--accent)]"
                  >
                    Retour au shop
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
}